import styled from 'styled-components'
import { HeadLine1, HeadLine3, BodySmall } from '../../components/typography/styled'

export const Container = styled.div`
  width: 100%;
  display: flex;
  box-sizing: border-box;
  flex-direction: column;
  padding: 10px 30px 50px 20px;
  gap:20px;
  position: relative;

  @media screen and (max-width: 768px) {
    min-width: 0;
    padding: 10px 16px 40px;
  }
`
export const TitleBig = styled(HeadLine1)`
  color:${({theme}) => theme.palette[850]};
  /* margin-top: 20px; */
`
export const GroupContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 10px;
`
export const DescWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap:2px;
  align-items: flex-start;
`
export const DiagramWrapper = styled.div`
  box-sizing: border-box;
  display: flex;
  gap:20px;
  align-items: center;
  text-align: center;
  padding: 10px 20px;
  max-width: 100%;
  flex-grow:1;
  flex-basis:0;
  background-color: ${({theme}) => theme.palette[10]};
  border: 1px solid rgba(186, 196, 211, 0.16);
  border-radius:12px;
  box-shadow: ${({theme}) => theme.shadows.card};
  /* &:hover {
    cursor: pointer;
    background: ${({theme}) => theme.isDark ? theme.palette[200] : theme.grey[100]};
  } */
  /* &:active{
    background-color: ${({theme}) => theme.isDark ? theme.palette[400] : theme.grey[200]};
    transition: 0.1s background-color ease-in-out;
  } */

  @media screen and (max-width: 768px) {
    min-width: 0;
    padding: 10px 14px;
  }
`

export const DiagramName = styled(HeadLine3)`
  color:${({theme}) => theme.neutral[100]};
`
export const Description = styled(BodySmall)`
  color:${({theme}) => theme.neutral[80]};
  overflow-wrap: anywhere;
`

export const Pie = styled.div`
  border-radius : 4px;
  width: 40px;
  height: 40px;
  aspect-ratio: 1;
  display: inline-grid;
  place-content: center;
  margin: 5px;
  border-radius: 50%;
  font-size: 25px;
  font-weight: bold;
  font-family: sans-serif;
  position: relative;
  overflow: hidden;
  transition:
    --quota-used var(--quota-duration, 0ms) cubic-bezier(0.22, 1, 0.36, 1),
    --quota-rotation var(--quota-duration, 0ms) cubic-bezier(0.22, 1, 0.36, 1);
  background: ${({theme}) => theme.isDark ? `linear-gradient(180deg, #535353 0%, #747474 100%);` : `linear-gradient(180deg, ${theme.accent[30]} 0%, ${theme.accent[10]} 100%)`};
  &:before {
    content: "";
    position: absolute;
    border-radius: 50%;
    inset: 0;
    background: ${({theme}) => theme.isDark ? '#6288FF' : 'linear-gradient(135deg, #5DA2F6 0%, #0069DA 100%)'};
    -webkit-mask: conic-gradient(#000 var(--quota-used, 0%), transparent 0);
    mask: conic-gradient(#000 var(--quota-used, 0%), transparent 0);
    transition: 0s all ease-in-out;
  }
`

export const PieBorder = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  width: 2px;
  height: calc(50% + 1px);
  background: ${({theme}) => theme.palette[10]};
  transform: translateX(-50%) rotate(180deg);
  transform-origin: 50% 0;

  &::before {
    content: "";
    position: absolute;
    inset: 0;
    background: ${({theme}) => theme.palette[10]};
    transform: rotate(var(--quota-rotation, 0deg));
    transform-origin: 50% 0;
  }
`
